import OBase from './OBase';

import * as Geometry from '../geometry';

export default class DuplicateData extends OBase {
  update () {
    let dInputTree = this.getObjectInput('Data');
    let nInputTree = this.getObjectInput('Number');

    let dOutput = this.outputs['Data'].paramObject;

    //let nInputTree2 = this.graft(nInputTree);
    let dataTrees = [dInputTree, nInputTree];
    let outDataTrees = [];

    Geometry.makeMultiplePairs(dataTrees, outDataTrees);

    let outTree = new Geometry.DataTree();

    for (let i = 0; i < outDataTrees[0].branches.length; i++) {

      const path = new Geometry.GHPath(outDataTrees[0].paths[i]);
      path.add(0);
      outTree.addEmpty(path);

      let dupNum = outDataTrees[1].branches[i][0];
      for (let t = 0; t < dupNum; t++) {
        for (let j = 0; j < outDataTrees[0].branches[i].length; j++) {
          let data = outDataTrees[0].branches[i][j];
          const path = new Geometry.GHPath(outDataTrees[0].paths[i]);
          path.add(0);
          outTree.add(data, path);
        }
      }
    }

    dOutput.value = outTree;
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/gh/components/DuplicateData.js